import { Injectable } from "@angular/core";

@Injectable()
export class FunctionsService {
  constructor() {}

  public getLevelId(): number {
    return JSON.parse(localStorage.getItem("educationalCenters")) &&
      JSON.parse(localStorage.getItem("educationalCenters")).level
      ? JSON.parse(localStorage.getItem("educationalCenters")).level.id
      : "";
  }

  public isEpda(): boolean {

    const educationalCenters = JSON.parse(localStorage.getItem("educationalCenters"));

    if(educationalCenters)
     return educationalCenters.epda;

    return false
  }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/functions.service.ts